import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CarDetailsModal from "../components/CarDetailsModal";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "../assets/css/style.css";

import api, { IMAGE_BASE_URL } from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

import tickImage from "../assets/images/tickm.png";
import lmap from "../assets/images/lmap.png";
import darrow from "../assets/images/darrow.png";

// =====================================================
// REGULAR CLIENT VERIFY ENDPOINT
// TODO: change this to your real endpoint.
// Expected response: { success: true, data: { client_id, email, name, phone, ... } }
// =====================================================

const CLIENT_VERIFY_ENDPOINT = "/bookings/verify-client";
function BookACar() {
  const { language, t } = useLanguage();
  const navigate = useNavigate();

  // =====================================================
  // TRANSLATION HELPER
  // =====================================================

  const tt = (key, fallback = "") =>
    t(`bookingengine.${key}`, fallback);

  // =====================================================
  // LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (
      typeof language === "number" ||
      !isNaN(Number(language))
    ) {
      return Number(language);
    }

    if (language && typeof language === "object") {
      return (
        Number(
          language.lang_id ||
            language.language_id ||
            language.id
        ) || 1
      );
    }

    return 1;
  };

  const languageId = getLanguageId();

  // =====================================================
  // STATES
  // =====================================================
const [showDetailsModal, setShowDetailsModal] = useState(false);
const [selectedCar, setSelectedCar] = useState(null);
const [detailsLoading, setDetailsLoading] = useState(false);
const [detailsError, setDetailsError] = useState("");
  const [criteria, setCriteria] = useState(null);
  const [modifyForm, setModifyForm] = useState(null);

  const [locations, setLocations] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);

  const [cars, setCars] = useState([]);
  const [loadingCars, setLoadingCars] = useState(true);

  const [expandedCars, setExpandedCars] = useState({});

  // =====================================================
  // REGULAR CLIENT STATES
  // =====================================================

  const [showRegularClientLogin, setShowRegularClientLogin] =
    useState(false);
  const [clientError, setClientError] = useState("");

  // =====================================================
  // CAR DETAILS MODAL
  // =====================================================

  const [showCarDetails, setShowCarDetails] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] =
    useState(null);
  const [loadingCarDetails, setLoadingCarDetails] =
    useState(false);

  // =====================================================
  // HOURS
  // =====================================================

  const hours = [];

  for (let i = 0; i <= 23; i++) {
    hours.push(String(i).padStart(2, "0"));
  }

  // =====================================================
  // MINUTES
  // =====================================================

  const minutes = ["00", "15", "30", "45"];

  // =====================================================
  // READ BOOKING CRITERIA
  // =====================================================

  useEffect(() => {
    try {
      const storedCriteria =
        sessionStorage.getItem("bookingCriteria");

      if (!storedCriteria) {
        console.warn("No bookingCriteria found");
        navigate("/");
        return;
      }

      const parsedCriteria = JSON.parse(storedCriteria);

      console.log(
        "Parsed booking criteria:",
        parsedCriteria
      );

      setCriteria(parsedCriteria);
      setModifyForm(parsedCriteria);

      // Regular client entered on first page -> keep fields open
      if (
        parsedCriteria.clientid ||
        parsedCriteria.clientemail
      ) {
        setShowRegularClientLogin(true);
      }
    } catch (error) {
      console.error(
        "Error reading booking criteria:",
        error
      );

      sessionStorage.removeItem("bookingCriteria");
      navigate("/");
    }
  }, [navigate]);

  // =====================================================
  // FETCH LOCATIONS
  // =====================================================

  useEffect(() => {
    fetchLocations();
  }, [languageId]);

  const fetchLocations = async () => {
    try {
      setLoadingLocations(true);

      console.log(
        "========================================"
      );
      console.log("LOCATION API");
      console.log("Language ID:", languageId);
      console.log(
        "========================================"
      );

      const response = await api.get(
        "/locations/getLocations",
        {
          params: {
            city_id: 1,
            lang_id: languageId,
          },
        }
      );

      console.log(
        "LOCATION API RESPONSE:",
        response
      );

      console.log(
        "LOCATION DATA:",
        response.data
      );

      console.log(
        "LOCATION STATUS:",
        response.status
      );

      const result = response.data;

      if (
        result &&
        result.success &&
        Array.isArray(result.data)
      ) {
        setLocations(result.data);

        console.log(
          "LOCATIONS SET:",
          result.data
        );
      } else {
        console.warn(
          "Invalid location response:",
          result
        );

        setLocations([]);
      }
    } catch (error) {
      console.error(
        "LOCATION API ERROR:",
        error
      );

      console.error(
        "ERROR RESPONSE:",
        error.response
      );

      console.error(
        "ERROR MESSAGE:",
        error.message
      );

      setLocations([]);
    } finally {
      setLoadingLocations(false);
    }
  };

  // =====================================================
  // LOCATION NAME
  // =====================================================

  const getLocationName = (locId) => {
    const found = locations.find(
      (loc) =>
        String(loc.loc_id) === String(locId)
    );

    return found ? found.loc_name : "";
  };

  // =====================================================
  // SEARCH CARS
  // =====================================================

  useEffect(() => {
    if (!criteria) {
      return;
    }

    if (
      !criteria.cmbPickLocation ||
      !criteria.pickdate ||
      !criteria.cmbDropLocation ||
      !criteria.returndate
    ) {
      setLoadingCars(false);
      return;
    }

    fetchMatchingCars(criteria);
  }, [criteria, languageId]);

  const fetchMatchingCars = async (
    bookingCriteria
  ) => {
    try {
      setLoadingCars(true);

      console.log(
        "========================================"
      );
      console.log("BOOKING SEARCH API");
      console.log(
        "========================================"
      );

      console.log(
        "Booking criteria:",
        bookingCriteria
      );

      const requestBody = {
        ...bookingCriteria,
        langid: languageId,
        lang_id: languageId,
      };

      const response = await api.post(
        "/bookings/search",
        requestBody,
        {
          params: {
            langid: languageId,
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log(
        "BOOKING SEARCH RESPONSE:",
        response
      );

      console.log(
        "BOOKING SEARCH DATA:",
        response.data
      );

      const result = response.data;

      if (
        result &&
        result.success &&
        Array.isArray(result.data)
      ) {
        setCars(result.data);
      } else {
        setCars([]);
      }
    } catch (error) {
      console.error(
        "ERROR LOADING CARS:",
        error
      );

      console.error(
        "ERROR RESPONSE:",
        error.response
      );

      setCars([]);
    } finally {
      setLoadingCars(false);
    }
  };

  // =====================================================
  // MODIFY SEARCH
  // =====================================================

  const handleModifySubmit = (e) => {
    e.preventDefault();

    if (!modifyForm) {
      return;
    }

    if (
      !modifyForm.cmbPickLocation ||
      !modifyForm.pickdate ||
      !modifyForm.cmbDropLocation ||
      !modifyForm.returndate
    ) {
      alert(
        tt(
          "completeBookingDetails",
          "Please complete pickup and return details."
        )
      );

      return;
    }

    const pickupDateTime = new Date(
      `${modifyForm.pickdate}T${modifyForm.cmbpickHour}:${modifyForm.cmbpickmin}:00`
    );

    const returnDateTime = new Date(
      `${modifyForm.returndate}T${modifyForm.cmbreturnHour}:${modifyForm.cmbreturnmin}:00`
    );

    if (returnDateTime <= pickupDateTime) {
      alert(
        tt(
          "returnDateAfterPickup",
          "Return date/time must be after pickup date/time."
        )
      );

      return;
    }

    // ---------------------------------------------
    // REGULAR CLIENT: both fields or neither
    // ---------------------------------------------
    const hasClientId = Boolean(
      String(modifyForm.clientid || "").trim()
    );
    const hasClientEmail = Boolean(
      String(modifyForm.clientemail || "").trim()
    );

    if (hasClientId !== hasClientEmail) {
      setClientError(
        tt(
          "clientIdAndEmailRequired",
          "Please enter both Client Id and Email."
        )
      );

      return;
    }

    setClientError("");

    sessionStorage.setItem(
      "bookingCriteria",
      JSON.stringify(modifyForm)
    );

    setCriteria({
      ...modifyForm,
    });
  };

  // =====================================================
  // VERIFY REGULAR CLIENT
  //
  // - No client id/email entered -> normal booking,
  //   any old "regularClient" data is cleared.
  // - Client id + email entered -> verified with backend,
  //   details saved in sessionStorage "regularClient" so
  //   BookACarThree can auto-fill the form.
  // =====================================================

  const verifyRegularClient = async () => {
    const clientid = String(criteria?.clientid || "").trim();
    const clientemail = String(
      criteria?.clientemail || ""
    ).trim();

    if (!clientid && !clientemail) {
      sessionStorage.removeItem("regularClient");
      return true;
    }

    if (!clientid || !clientemail) {
      alert(
        tt(
          "clientIdAndEmailRequired",
          "Please enter both Client Id and Email."
        )
      );

      return false;
    }

    try {
      const response = await api.post(
        CLIENT_VERIFY_ENDPOINT,
        { clientid, clientemail }
      );

      const result = response.data;
console.log("VERIFY RESULT:", result);
      if (result && result.success && result.data) {
        sessionStorage.setItem(
          "regularClient",
          JSON.stringify({
            ...result.data,
            clientid,
            clientemail,
          })
        );

        return true;
      }
    } catch (error) {
      console.error(
        "REGULAR CLIENT VERIFY ERROR:",
        error
      );
    }

    sessionStorage.removeItem("regularClient");

    alert(
      tt(
        "regularClientNotFound",
        "Regular client details not found. Please check your Client Id and Email."
      )
    );

    return false;
  };

  // =====================================================
  // CAR IMAGE
  // =====================================================
  const getCarImage = (image) => {
    if (!image) {
      return "";
    }

    let imagePath = String(image).trim();

    if (!imagePath) {
      return "";
    }

    if (
      imagePath.startsWith("http://") ||
      imagePath.startsWith("https://")
    ) {
      return imagePath;
    }

    imagePath = imagePath.replace(/^\/+/, "");

    const imageBase =
      IMAGE_BASE_URL || "http://localhost:5555/uploads";

    if (imagePath.startsWith("images/")) {
      return `${imageBase}/${imagePath}`;
    }

    if (imagePath.startsWith("CarImage/")) {
      return `${imageBase}/images/${imagePath}`;
    }

    return `${imageBase}/images/CarImage/${imagePath}`;
  };

  // =====================================================
  // IMAGE ERROR
  // =====================================================

  const handleImageError = (e) => {
    console.error(
      "CAR IMAGE FAILED:",
      e.currentTarget.src
    );

    e.currentTarget.style.display = "none";

    const fallback =
      e.currentTarget.parentElement?.querySelector(
        ".image-fallback"
      );

    if (fallback) {
      fallback.style.display = "flex";
    }
  };

  // =====================================================
  // SHOW MORE / LESS
  // =====================================================

  const toggleExpanded = (carId) => {
    setExpandedCars((previous) => ({
      ...previous,
      [carId]: !previous[carId],
    }));
  };

  // =====================================================
  // CAR DETAILS
  // =====================================================

  const handleCarDetails = async (car) => {
    const carmodelId =
      car.carmodel_id || car.id;

    if (!carmodelId) {
      alert(
        tt(
          "carModelIdMissing",
          "Car model ID is missing."
        )
      );

      return;
    }

    try {
      setLoadingCarDetails(true);
      setShowCarDetails(true);
      setSelectedCarDetails(null);

      console.log(
        "Fetching car details:",
        carmodelId
      );

      const response = await api.get(
        `/cars/${carmodelId}/details`,
        {
          params: {
            langid: languageId,
          },
        }
      );

      console.log(
        "CAR DETAILS RESPONSE:",
        response
      );

      console.log(
        "CAR DETAILS DATA:",
        response.data
      );

      const result = response.data;

      if (
        result &&
        result.success &&
        result.data
      ) {
        setSelectedCarDetails(
          result.data
        );
      } else {
        throw new Error(
          tt(
            "carDetailsNotFound",
            "Car details not found"
          )
        );
      }
    } catch (error) {
      console.error(
        "Car details error:",
        error
      );

      console.error(
        "Car details error response:",
        error.response
      );

      setSelectedCarDetails({
        error: error.message,
      });
    } finally {
      setLoadingCarDetails(false);
    }
  };

  // =====================================================
  // CLOSE CAR DETAILS
  // =====================================================

  const closeCarDetails = () => {
    setShowCarDetails(false);
    setSelectedCarDetails(null);
  };

  // =====================================================
  // BOOK CAR
  // =====================================================

  const handleBookCar = async (car) => {
    const selectedmodelid =
      car.carmodel_id || car.id;

    const selectedcatid =
      car.cat_id ||
      car.category_id;

    if (!selectedmodelid) {
      alert(
        tt(
          "carModelIdMissing",
          "Car model ID is missing."
        )
      );

      return;
    }

    if (!selectedcatid) {
      alert(
        tt(
          "carCategoryIdMissing",
          "Car category ID is missing."
        )
      );

      return;
    }

    // Regular client check (skipped for normal customers)
    const clientOk = await verifyRegularClient();

    if (!clientOk) {
      return;
    }

    const selectedCarData = {
      ...car,
      selectedmodelid,
      selectedcatid,
    };

    sessionStorage.setItem(
      "selectedCar",
      JSON.stringify(selectedCarData)
    );

    if (criteria) {
      sessionStorage.setItem(
        "bookingCriteria",
        JSON.stringify(criteria)
      );
    }

    navigate("/bookacarthree");
  };

  // =====================================================
  // SEND REQUEST FOR UNAVAILABLE / REQUEST-ONLY CAR
  //
  // Used when car.availabilityStatus is NOT "available"
  // (i.e. "non_available", "fully_booked", or "request").
  //
  // NOTE: Update the navigate() target below to match
  // whatever request/contact route or modal you actually
  // use for this flow.
  // =====================================================

  const handleSendRequest = async (car) => {
    const selectedmodelid =
      car.carmodel_id || car.id;

    const selectedcatid =
      car.cat_id ||
      car.category_id;

    // Regular client check (skipped for normal customers)
    const clientOk = await verifyRegularClient();

    if (!clientOk) {
      return;
    }

    const requestCarData = {
      ...car,
      selectedmodelid,
      selectedcatid,
    };

    sessionStorage.setItem(
      "requestCar",
      JSON.stringify(requestCarData)
    );

    if (criteria) {
      sessionStorage.setItem(
        "bookingCriteria",
        JSON.stringify(criteria)
      );
    }

    navigate("/sendrequest");
  };

  // =====================================================
  // RENTAL PRICE
  // =====================================================

  // const getRentalPrice = (car) => {
  //   const price = Number(
  //     car.price_perday ??
  //       car.pricePerDay ??
  //       0
  //   );

  //   const days = Number(
  //     car.diffdate ??
  //       criteria?.diffdate ??
  //       1
  //   );

  //   if (price <= 0) {
  //     return Number(
  //       car.finalPrice ?? 0
  //     );
  //   }

  //   return Number(
  //     (
  //       price *
  //       Math.max(days, 1)
  //     ).toFixed(2)
  //   );
  // };
// =====================================================
// RENTAL PRICE
// Backend search API already calculates pricePerDay/finalPrice
// =====================================================
const getRentalPrice = (car) => {
  const rentalDays = Number(
    car.rentalDays ??
      car.diffdate ??
      criteria?.diffdate ??
      1
  );

  const finalPrice = Number(
    car.finalPrice ??
      car.final_price ??
      0
  );

  if (finalPrice > 0) {
    return Number(finalPrice.toFixed(2));
  }

  const pricePerDay = Number(
    car.pricePerDay ??
      car.price_perday ??
      0
  );

  return Number(
    (pricePerDay * Math.max(rentalDays, 1)).toFixed(2)
  );
};

// =====================================================
// FINAL PRICE
// Backend finalPrice is the authoritative rental total
// =====================================================
const getFinalPrice = (car) => {
  const finalPrice = Number(
    car.finalPrice ??
      car.final_price ??
      0
  );

  if (finalPrice > 0) {
    return Number(finalPrice.toFixed(2));
  }

  return getRentalPrice(car);
};
  // =====================================================
  // FINAL PRICE
  // =====================================================

  // const getFinalPrice = (car) => {
  //   return Number(
  //     car.finalPrice ??
  //       car.final_price ??
  //       getRentalPrice(car)
  //   );
  // };

  // =====================================================
  // FEATURES
  // =====================================================

  const getFeatures = (car) => {
    if (
      Array.isArray(
        car?.includedItems
      ) &&
      car.includedItems.length > 0
    ) {
      return car.includedItems
        .map((item) => {
          if (
            item &&
            typeof item === "object"
          ) {
            return (
              item.item_name ||
              item.name ||
              item.mldynsec_val ||
              item.value ||
              ""
            );
          }

          return String(item);
        })
        .filter(Boolean);
    }

    if (
      Array.isArray(car?.features) &&
      car.features.length > 0
    ) {
      return car.features
        .map((item) => {
          if (
            item &&
            typeof item === "object"
          ) {
            return (
              item.item_name ||
              item.name ||
              item.mldynsec_val ||
              item.value ||
              ""
            );
          }

          return String(item);
        })
        .filter(Boolean);
    }

    return [];
  };

  // =====================================================
  // LOADING CRITERIA
  // =====================================================

  if (!criteria) {
    return (
      <div
        className="container text-center"
        style={{
          paddingTop: "100px",
          paddingBottom: "100px",
        }}
      >
        <p>
          {tt(
            "loadingBookingDetails",
            "Loading booking details..."
          )}
        </p>
      </div>
    );
  }

  // =====================================================
  // RETURN
  // =====================================================

  return (
    <div className="p20">
      <div className="p0 container container2">

        {/* =====================================================
            SIDEBAR
        ===================================================== */}

        <div
          className="col-md-3 sidebar"
          style={{ float: "left" }}
        >
          <div className="booking-wrapper">

            {/* BOOKING CARD */}

            <div className="booking-card">
              <div className="card-header">

                <h3>
                  {tt(
                    "yourBooking",
                    "Your booking"
                  )}
                </h3>

                <label
                  className="search-btn"
                  htmlFor="check"
                >
                  {tt(
                    "modify",
                    "Modify"
                  )}

                  {" "}

                  <img
  src={darrow}
  alt=""
  style={{
    width: "13px",
    height: "13px",
    objectFit: "contain",
    marginLeft: "5px",
    verticalAlign: "middle",
  }}
/>

                </label>

              </div>

              {/* PICKUP */}

              <div className="booking-item">

                <div className="icon-area">
                  <div className="icon">
                      <img
  src={lmap}
  alt=""
  style={{
    width: "20px",
    height: "20px",
    objectFit: "contain",
  }}
/>

                  </div>

                  <div className="line"></div>
                </div>

                <div className="booking-content">

                  <h4>
                    {loadingLocations
                      ? tt(
                          "loading",
                          "Loading..."
                        )
                      : getLocationName(
                          criteria.cmbPickLocation
                        ) ||
                        tt(
                          "pickupLocation",
                          "Pickup location"
                        )}
                  </h4>

                  <p>
                    {criteria.pickdate} @{" "}
                    {criteria.cmbpickHour}:
                    {criteria.cmbpickmin}
                  </p>

                </div>

              </div>

              {/* RETURN */}

              <div className="booking-item">

                <div className="icon-area">

                  <div className="icon">
                     <img
  src={lmap}
  alt=""
  style={{
    width: "20px",
    height: "20px",
    objectFit: "contain",
  }}
/>

                  </div>

                </div>

                <div className="booking-content">

                  <h4>
                    {loadingLocations
                      ? tt(
                          "loading",
                          "Loading..."
                        )
                      : getLocationName(
                          criteria.cmbDropLocation
                        ) ||
                        tt(
                          "returnLocation",
                          "Return location"
                        )}
                  </h4>

                  <p>
                    {criteria.returndate} @{" "}
                    {criteria.cmbreturnHour}:
                    {criteria.cmbreturnmin}
                  </p>

                </div>

              </div>

              {/* REGULAR CLIENT INFO (only when a client id is set) */}

              {criteria.clientid && (
                <div
                  style={{
                    fontSize: "13px",
                    padding: "8px 15px",
                    color: "#555",
                  }}
                >
                  {tt(
                    "regularClient",
                    "Regular client"
                  )}
                  : <strong>{criteria.clientid}</strong>
                </div>
              )}

            </div>

            {/* MODIFY CHECKBOX */}

            <input
              id="check"
              type="checkbox"
              style={{ display: "none" }}
            />

            <div className="test">
              <div className="test-box">

                <form
                  onSubmit={
                    handleModifySubmit
                  }
                >

                  {/* PICKUP */}

                  <div
                    className="col-md-12"
                    style={{
                      float: "left",
                      padding: 0,
                    }}
                  >

                    <label className="label">
                      <strong>
                        {tt(
                          "pickupInformation",
                          "Pickup Information"
                        )}
                      </strong>
                    </label>

                    {/* PICKUP LOCATION */}

                    <div className="col-lg-12 form-group p0">

                      <select
                        className="arrow  form-control select"
                        value={
                          modifyForm?.cmbPickLocation ||
                          ""
                        }
                        onChange={(e) =>
                          setModifyForm(
                            (prev) => ({
                              ...prev,
                              cmbPickLocation:
                                e.target.value,
                            })
                          )
                        }
                      >

                        <option value="">
                          {tt(
                            "selectLocation",
                            "Select location"
                          )}
                        </option>

                        {locations.map(
                          (loc) => (
                            <option
                              key={
                                loc.loc_id
                              }
                              value={
                                loc.loc_id
                              }
                            >
                              {
                                loc.loc_name
                              }
                            </option>
                          )
                        )}

                      </select>

                    </div>

                    {/* PICKUP DATE */}

                    <div className="col-lg-12 form-group p0">

                      <input
                        type="date"
                        className=" form-control"
                        value={
                          modifyForm?.pickdate ||
                          ""
                        }
                        onChange={(e) =>
                          setModifyForm(
                            (prev) => ({
                              ...prev,
                              pickdate:
                                e.target.value,
                            })
                          )
                        }
                      />

                    </div>

                    {/* PICKUP TIME */}

                    <div className="col-lg-12 form-group p0" >

                      <div
                        style={{
                          display: "flex",
                          gap: "3px",
                        }}
                      >

                        <select
                          className="arrow form-control"
                          value={
                            modifyForm?.cmbpickHour ||
                            "10"
                          }
                          onChange={(e) =>
                            setModifyForm(
                              (prev) => ({
                                ...prev,
                                cmbpickHour:
                                  e.target.value,
                              })
                            )
                          }
                        >

                          {hours.map(
                            (hour) => (
                              <option
                                key={hour}
                                value={hour}
                              >
                                {hour}
                              </option>
                            )
                          )}

                        </select>

                        <select
                          className="arrow form-control"
                          value={
                            modifyForm?.cmbpickmin ||
                            "00"
                          }
                          onChange={(e) =>
                            setModifyForm(
                              (prev) => ({
                                ...prev,
                                cmbpickmin:
                                  e.target.value,
                              })
                            )
                          }
                        >

                          {minutes.map(
                            (minute) => (
                              <option
                                key={minute}
                                value={minute}
                              >
                                {minute}
                              </option>
                            )
                          )}

                        </select>

                      </div>

                    </div>

                  </div>

                  {/* RETURN */}

                  <div
                    className="col-md-12 p0"
                    style={{
                      float: "left",
                      padding: 0,
                    }}
                  >

                    <label className="label">

                      <strong>
                        {tt(
                          "returnInformation",
                          "Return Information"
                        )}
                      </strong>

                    </label>

                    {/* RETURN LOCATION */}

                    <div className="col-lg-12 form-group p0">

                      <select
                        className="arrow form-control select"
                        value={
                          modifyForm?.cmbDropLocation ||
                          ""
                        }
                        onChange={(e) =>
                          setModifyForm(
                            (prev) => ({
                              ...prev,
                              cmbDropLocation:
                                e.target.value,
                            })
                          )
                        }
                      >

                        <option value="">
                          {tt(
                            "selectLocation",
                            "Select location"
                          )}
                        </option>

                        {locations.map(
                          (loc) => (
                            <option
                              key={
                                loc.loc_id
                              }
                              value={
                                loc.loc_id
                              }
                            >
                              {
                                loc.loc_name
                              }
                            </option>
                          )
                        )}

                      </select>

                    </div>

                    {/* RETURN DATE */}

                    <div className="col-lg-12 form-group p0">

                      <input
                        type="date"
                        className=" form-control"
                        value={
                          modifyForm?.returndate ||
                          ""
                        }
                        onChange={(e) =>
                          setModifyForm(
                            (prev) => ({
                              ...prev,
                              returndate:
                                e.target.value,
                            })
                          )
                        }
                      />

                    </div>

                    {/* RETURN TIME */}

                    <div className="col-lg-12 form-group p0">

                      <div
                        style={{
                          display: "flex",
                          gap: "3px",
                        }}
                      >

                        <select
                          className="arrow form-control"
                          value={
                            modifyForm?.cmbreturnHour ||
                            "10"
                          }
                          onChange={(e) =>
                            setModifyForm(
                              (prev) => ({
                                ...prev,
                                cmbreturnHour:
                                  e.target.value,
                              })
                            )
                          }
                        >

                          {hours.map(
                            (hour) => (
                              <option
                                key={hour}
                                value={hour}
                              >
                                {hour}
                              </option>
                            )
                          )}

                        </select>

                        <select
                          className="arrow form-control"
                          value={
                            modifyForm?.cmbreturnmin ||
                            "00"
                          }
                          onChange={(e) =>
                            setModifyForm(
                              (prev) => ({
                                ...prev,
                                cmbreturnmin:
                                  e.target.value,
                              })
                            )
                          }
                        >

                          {minutes.map(
                            (minute) => (
                              <option
                                key={minute}
                                value={minute}
                              >
                                {minute}
                              </option>
                            )
                          )}

                        </select>

                      </div>

                    </div>

                  </div>

                  {/* BUTTONS */}

                  <div
                    className="col-md-12"
                    style={{
                      padding: 0,
                      float: "left",
                      
                    }}
                  >

                    <input
                      type="submit"
                      value={
                        loadingCars
                          ? tt(
                              "searching",
                              "Searching..."
                            )
                          : tt(
                              "continue",
                              "Continue"
                            )
                      }
                      disabled={
                        loadingCars
                      }
                      className="btn btn-secondary1"
                      style={{
                        padding: "4px 0px",
                        width: "100%",
                      }}
                    />

                    {/* REGULAR CLIENT LOGIN (toggle) */}

                    <button
                      type="button"
                      className="btn btn-secondary2 py-3 px-4"
                      onClick={() =>
                        setShowRegularClientLogin(
                          (prev) => !prev
                        )
                      }
                    >
                      {tt(
                        "regularClientLogin",
                        "Regular client Login"
                      )}
                    </button>

                    {/* REGULAR CLIENT DETAILS */}

                    {showRegularClientLogin && (
                      <div
                        style={{
                          marginTop: "10px",
                          float: "left",
                          width: "100%",
                        }}
                      >

                        <input
                          type="text"
                          className="form-control"
                          maxLength="30"
                          placeholder="Client Id. :"
                          value={
                            modifyForm?.clientid ||
                            ""
                          }
                          onChange={(e) =>
                            setModifyForm(
                              (prev) => ({
                                ...prev,
                                clientid:
                                  e.target.value,
                              })
                            )
                          }
                        />

                        <input
                          type="text"
                          className="form-control"
                          style={{
                            marginTop: "6px",
                          }}
                          maxLength="100"
                          placeholder="Email Id. :"
                          value={
                            modifyForm?.clientemail ||
                            ""
                          }
                          onChange={(e) =>
                            setModifyForm(
                              (prev) => ({
                                ...prev,
                                clientemail:
                                  e.target.value,
                              })
                            )
                          }
                        />

                        {clientError && (
                          <div
                            style={{
                              color: "#d9302f",
                              fontSize: "13px",
                              marginTop: "4px",
                            }}
                          >
                            {clientError}
                          </div>
                        )}

                      </div>
                    )}

                  </div>

                </form>

              </div>
            </div>

          </div>

          <div className="clearfix"></div>
        </div>

        {/* =====================================================
            MAIN CONTENT
        ===================================================== */}

        <div
          className="col-md-9 main-content"
          style={{ float: "left" }}
        >

          {/* LOADING */}

          {loadingCars && (
            <div
              className="text-center"
              style={{
                padding: "50px",
              }}
            >
              <p>
                {tt(
                  "loadingCars",
                  "Loading cars..."
                )}
              </p>
            </div>
          )}

          {/* NO CARS */}

          {!loadingCars &&
            cars.length === 0 && (
              <div
                className="text-center"
                style={{
                  padding: "50px",
                }}
              >
                <p>
                  {tt(
                    "noCarsAvailable",
                    "No cars available for this search."
                  )}
                </p>
              </div>
            )}

          {/* CAR LIST */}

          {!loadingCars &&
            cars.length > 0 &&
            cars.map((car, index) => {

              const carId =
                car.carmodel_id ||
                car.id ||
                index;

              const carImage =
                getCarImage(
                  car.carmodel_image ||
                    car.image
                );

              const features =
                getFeatures(car);

              const mainFeatures =
                features.slice(0, 4);

              const extraFeatures =
                features.slice(4);

              const isExpanded =
                Boolean(
                  expandedCars[carId]
                );

              const rentalPrice =
                getRentalPrice(car);

              const finalPrice =
                getFinalPrice(car);

              // =========================================
              // AVAILABILITY
              //
              // Backend returns availabilityStatus:
              //   "available"     -> show price + Continue
              //   "non_available" -> show request message
              //   "fully_booked"  -> show request message
              //   "request"       -> show request message
              // =========================================

              const isAvailable =
                car.availabilityStatus ===
                  "available" ||
                car.availabilityStatus ===
                  undefined;

              return (
                <div
                  className="rental-card"
                  key={carId}
                >

                  {/* TITLE */}

                  <div className="">

                    <div
                      className="col-xs-12 col-sm-8 col-md-8 col-lg-8"
                      style={{
                        float: "left",
                      }}
                    >

                      <h2 className="car-title">

                        {car.carmodel_name ||
                          car.name ||
                          tt(
                            "car",
                            "Car"
                          )}

                      </h2>

                      <div className="car-subtitle">

                        {car.cat_name ||
                          car.category ||
                          ""}

                      </div>

                    </div>

                    {/* PRICE / UNAVAILABLE MESSAGE */}

                    <div
                      className="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                      style={{
                        float: "left",
                      }}
                    >

                      {isAvailable ? (

                        <div className="price-container">
    
                      <div className="clearfix"></div>
                          <div className="price-label">

                            {t(
                              "ratechart.ratechart23",
                              "Final Price"
                            )}

                          </div>

                          <div className="main-price">

                            &euro;{" "}

                            {finalPrice.toFixed(
                              2
                            )}

                          </div>

                          <div className="price-inner"
                          
                          >

                            {t(
                              "ratechart.ratechart5",
                              "Rental price"
                            )}

                            {" "}

                            <span
                              style={{
                                fontWeight: "600",
                                color: "#9b260f",
                                textDecoration:
                                  "line-through",
                              }}
                            >

                              &euro;{" "}

                              {rentalPrice.toFixed(
                                2
                              )}

                            </span>

                          </div>

                        </div>

                      ) : (

                        <div
                          style={{
                            color: "#d9302f",
                            fontSize: "13px",
                            lineHeight: "1.4",
                            textAlign: "center",
                            padding: "10px 5px",
                          }}
                        >

                          {car.availabilityMessage ||
                            tt(
                              "carNotAvailable",
                              "Choose another group or period, or click here to send a request for this car"
                            )}

                        </div>

                      )}

                    </div>
<div className="clearfix"></div>
                  </div>

                  <div className="clearfix"></div>

                  {/* IMAGE */}

                  <div
                    className="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                    style={{
                      float: "left",
                    }}
                  >

                    <div
                      className="image-container"
                      style={{
                        minHeight: "180px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >

                      <div
                        className="image-fallback"
                        style={{
                          display: carImage
                            ? "none"
                            : "flex",
                          alignItems: "center",
                          justifyContent:
                            "center",
                          color: "#999",
                        }}
                      >

                        {tt(
                          "noImage",
                          "No Image"
                        )}

                      </div>

                      {carImage && (
                        <img
                          src={carImage}
                          alt={
                            car.carmodel_name ||
                            tt(
                              "car",
                              "Car"
                            )
                          }
                          className="car-img"
                          loading="lazy"
                          onError={
                            handleImageError
                          }
                          onLoad={() =>
                            console.log(
                              "IMAGE LOADED:",
                              carImage
                            )
                          }
                        />
                      )}

                    </div>

                  </div>

                  {/* FEATURES */}

                  <div
                    className="col-xs-12 col-sm-12 col-md-5 col-lg-5"
                    style={{
                      float: "left",
                    }}
                  >

                    <div className="features-container">

                  <div className="specs-row">

                        <span className="spec-tag">
                          👤{" "}
                          {car.carmodel_passgrno ??
                            car.passengers ??
                            0}
                        </span>

                        <span className="spec-tag">
                          🧳{" "}
                          {car.carmodel_luggno ??
                            car.luggage ??
                            0}
                        </span>

                        <span className="spec-tag">
                          ❄️{" "}
                          {car.carmodel_airconditionr ||
                            car.airConditioning ||
                            tt(
                              "no",
                              "No"
                            )}
                        </span>

                      <span className="spec-tag">
    🚪{" "}
    {car.carmodel_doors ??
      car.doors ??
      "-"}
  </span>

                      </div>

                      {mainFeatures.map(
                        (
                          feature,
                          featureIndex
                        ) => (
                          <div
                            className="feature-item"
                            key={
                              featureIndex
                            }
                            style={{
                              display: "flex",
                              alignItems:
                                "center",
                              
                            }}
                          >

                        <img
  src={tickImage}
  alt="Included"
  className="feature-icon"
  style={{
    width: "20px",
    height: "20px",
    minWidth: "20px",
    objectFit: "contain",
    marginRight: "8px",
    display: "inline-block",
    verticalAlign: "middle",
  }}
/>

                            <strong>
                              {typeof feature ===
                              "string"
                                ? feature
                                : ""}
                            </strong>

                          </div>
                        )
                      )}

                      {extraFeatures.length >
                        0 && (
                        <div
                          style={{
                            marginTop: "10px",
                          }}
                        >

                          <button
                          className="showmore"
                            type="button"
                            onClick={() =>
                              toggleExpanded(
                                carId
                              )
                            }
                          
                          >
                            {isExpanded
                              ? tt(
                                  "showLess",
                                  "Show less"
                                )
                              : `${tt(
                                  "show",
                                  "Show"
                                )} ${
                                  extraFeatures.length
                                } ${tt(
                                  "more",
                                  "More"
                                )}`}
                          </button>

                          {isExpanded && (
                            <div
                            
                            >

                              {extraFeatures.map(
                                (
                                  feature,
                                  featureIndex
                                ) => (
                                  <div
                                  className="feature-item"
                                    key={
                                      featureIndex
                                    }
                                    style={{
                                      display:
                                        "flex",
                                      alignItems:
                                        "center",
                                     
                                    }}
                                  >

                                   <img
  src={tickImage}
  alt="Included"
  className="feature-icon"
  style={{
    width: "20px",
    height: "20px",
    minWidth: "20px",
    objectFit: "contain",
    marginRight: "8px",
    display: "inline-block",
    verticalAlign: "middle",
  }}
/>

                                    <strong>
                                      {typeof feature ===
                                      "string"
                                        ? feature
                                        : ""}
                                    </strong>

                                  </div>
                                )
                              )}

                            </div>
                          )}

                        </div>
                      )}

                    </div>

                  </div>

                  {/* BUTTONS */}

                  <div
                    className="col-xs-12 col-sm-3 col-md-3 col-lg-3"
                    style={{
                      float: "left",
                    }}
                  >

                    <div className="actions-container">

                      <div className="car-d">

                        <button
                          type="button"
                          style={{
                            border: "none",
                            background:
                              "#087cff",
                            color: "#fff",
                            borderRadius:
                              "5px",
                            padding:
                              "7px 15px",
                            cursor:
                              "pointer",
                          }}
                          onClick={() =>
                            handleCarDetails(
                              car
                            )
                          }
                        >

                          {t(
                            "carparams.carparams2",
                            "Car details"
                          )}

                        </button>

                      </div>

                      {isAvailable ? (

                        <button
                          type="button"
                          className="book-btn"
                           
                          onClick={() =>
                            handleBookCar(
                              car
                            )
                          }
                        >

                          {tt(
                            "bookThis",
                            "Continue"
                          )}

                        </button>

                      ) : (

                        <button
                          type="button"
                          className="book-btn"
                          style={{
                            background:
                              "#d9302f",
                              width: 
                              "93%",
                              padding:
                               "5px 0",
                          }}
                          onClick={() =>
                            handleSendRequest(
                              car
                            )
                          }
                        >

                          {tt(
                            "sendRequest",
                            "Send Request"
                          )}

                        </button>

                      )}

                    </div>

                  </div>

                  <div className="clearfix"></div>

                </div>
              );
            })}

        </div>

        <div className="clearfix"></div>

      </div>

      {/* =====================================================
          CAR DETAILS MODAL (from components)
      ===================================================== */}

      <CarDetailsModal
        show={showCarDetails}
        onClose={closeCarDetails}
        car={
          selectedCarDetails?.error
            ? null
            : selectedCarDetails
        }
        loading={loadingCarDetails}
        error={selectedCarDetails?.error || ""}
        tt={tt}
        getCarImage={getCarImage}
        getFeatures={getFeatures}
        onBook={(car) => {
          closeCarDetails();
          handleBookCar(car);
        }}
      />

    </div>
  );
}

export default BookACar;
